export const PAGE_SIZE = 60;

// Grow the rendered window by one page, clamped to the total result count.
export function nextVisibleCount(current: number, total: number, pageSize: number): number {
  return Math.min(current + pageSize, total);
}
